import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '../../_infrastructure/objectUtils';
import { LoadingMaskService } from '../../_infrastructure/LoadingMask/LoadingMaskService';


@Component({
  selector: 'submit-pre-stage-request.component-pm-modal',
  templateUrl: './submit-pre-stage-request.component.html',
  styleUrl:'submit-pre-stage-request.component.scss',
  standalone: false
})
export class SubmitPreStageRequestModalComponent implements OnInit {
  public modal: models.BaseModalVM = <models.BaseModalVM>{}
  public onResult: Subject<boolean>;
  public resposta: boolean = null;

  public get cancelText() {
    return this.getButtonText(this.modal.cancelButton, "BaseModal.Cancel");
  }
  public get cancelIcon() {
    return this.getButtonIconClass(this.modal.cancelButton, "icon-close");
  }
  public get cancelButtonClass() {
    return this.getButtonClass(this.modal.cancelButton, "btn-outline-primary");
  }
  public get confirmIcon() {
    return this.getButtonIconClass(this.modal.confirmButton, "icon-check");
  }
  public get confirmText() {
    return this.getButtonText(this.modal.confirmButton, "BaseModal.Continue");
  }

  constructor(public modalRef: BsModalRef, private translate: TranslateService, private loadingMaskService: LoadingMaskService) {
  }

  ngOnInit(): void {
    this.onResult = new Subject();
  }
  decline(): void {
    this.loadingMaskService.setShowLoading(false, false);
    this.onResult.next(false);
    this.modalRef.hide();
  }
  confirm(): void {
    this.loadingMaskService.setShowLoading(false, false);
    const result: string = this.resposta ? 'continuar' : 'iniciar';
    this.onResult.next(true);
    this.modalRef.hide();
  }

  getButtonText(button: models.ModalButtonVM, defaultText: string) {
    if (isNullOrUndefined(button?.buttonText) || button?.buttonText == "")
      return this.translate.instant(defaultText);
    else
      return button?.buttonText;
  }

  getButtonIconClass(button: models.ModalButtonVM, defaultClass: string) {
    if (isNullOrUndefined(button?.iconClass) || button?.iconClass == "")
      return defaultClass;
    else
      return button?.iconClass;
  }

  getButtonClass(button: models.ModalButtonVM, defaultClass: string) {
    if (isNullOrUndefined(button?.buttonClass) || button?.buttonClass == "")
      return defaultClass;
    else
      return button?.buttonClass;
  }

  onResposta(answer) {
    this.resposta = answer;
  }
} 
